@if (!isChrome) {
  <div class="info-message-main">
    <mat-icon class="info-icon">info</mat-icon>
    <span>EstImage Online is optimized for Google Chrome or Microsoft Edge</span>
  </div>
}
